import { Network } from '@shared/types'
import { fromBase64 } from '@injectivelabs/sdk-ts/utils'
import { transactionCompleteStates } from '@/app/data/transaction'
import { TransactionState } from '@/types'
import type { ExplorerTransaction } from '@injectivelabs/sdk-ts'
import type { UiPendingTransactionWithKey } from '@/types'

const getIbcTransactionExplorerLink = (
  transactions: ExplorerTransaction[],
  pendingTransaction: UiPendingTransactionWithKey
): string => {
  const INJECTIVE_TO_GATEWAY_CHANNEL = 'channel-13'
  const IBC_MESSAGE_TYPE = '/ibc.core.channel.v1.MsgRecvPacket'

  const initialTransactionIndex = transactions.findIndex(
    (tx) => tx.hash === pendingTransaction.txHash
  )

  const transactionsAfterIntitial = transactions
    .slice(0, initialTransactionIndex)
    .reverse()

  const ibcTransaction = transactionsAfterIntitial.find((tsx) =>
    tsx.messages.some((msg) => {
      if (
        msg.type !== IBC_MESSAGE_TYPE ||
        msg.message.packet.source_channel !== INJECTIVE_TO_GATEWAY_CHANNEL
      ) {
        return false
      }

      const decodedData = fromBase64(msg.message.packet.data)

      return (
        decodedData.amount === pendingTransaction.amount &&
        decodedData.sender.startsWith('wormhole')
      )
    })
  )

  return ibcTransaction
    ? `${getExplorerUrl()}/transaction/${ibcTransaction.hash}/`
    : ''
}

export const mapWormholeMigrationTransaction = ({
  pendingTransaction,
  transactions
}: {
  transactions: ExplorerTransaction[]
  pendingTransaction: UiPendingTransactionWithKey
}): UiPendingTransactionWithKey => {
  if (transactionCompleteStates.includes(pendingTransaction.state)) {
    return pendingTransaction
  }

  if (
    pendingTransaction.network !== Network.Injective ||
    pendingTransaction.sender !== pendingTransaction.receiver
  ) {
    return pendingTransaction
  }

  const ibcTransactionExplorerLink = getIbcTransactionExplorerLink(
    transactions,
    pendingTransaction
  )

  if (!ibcTransactionExplorerLink) {
    return pendingTransaction
  }

  return {
    ...pendingTransaction,
    state: TransactionState.Completed,
    explorerLink: ibcTransactionExplorerLink,
    explorerLinkMap: {
      ...pendingTransaction.explorerLinkMap,
      [TransactionState.Completed]: ibcTransactionExplorerLink
    }
  }
}
